import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatDividerModule } from '@angular/material/divider';

@Component({
  selector: 'pixl-styleguide-dialog',
  imports: [
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    FormsModule,
    ReactiveFormsModule,
    MatSelectModule,
    MatDividerModule
  ],
  templateUrl: './styleguide-dialog.component.html',
  styleUrl: './styleguide-dialog.component.scss'
})
export class StyleguideDialogComponent {
  fb = inject(FormBuilder);
  dialogRef = inject(MatDialogRef);
  public comboBoxValues: string[] = ['Wert1', 'Wert2', 'Wert3', 'Wert4', 'Wert5'];

  userForm = this.fb.group({
    name: ['', [Validators.required]],
    url: ['', [Validators.required]],
    description: ['', [Validators.required]],
  });

  onSave(): void {
    this.dialogRef.close();
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
